<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="campaigns">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm10 elevation-6>
                <div class="sub-window">
                    <v-toolbar dense dark color="light-blue darken-4">
                        <v-toolbar-title>Campañas&nbsp;&nbsp;</v-toolbar-title>
                        <v-text-field
                            :disabled="bEdit"
                            hide-details
                            single-line
                            v-model="searchText"
                        ></v-text-field>
                        <v-btn :disabled="bEdit" small icon @click="onSearch">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-toolbar-items class="hidden-sm-and-down">
                            <v-btn
                                :disabled="bEdit"
                                text
                                class="text-none"
                                @click="onNewCampaign"
                            >Nueva Campaña</v-btn>
                            <v-btn
                                :disabled="(bEdit || campaignID === 0 )"
                                text
                                class="text-none"
                                @click="onEditCampaign"
                            >Editar Campaña</v-btn>
                            <v-btn
                                :disabled="(bEdit || campaignID === 0 )"
                                text
                                class="text-none"
                                @click="onDeleteCampaign"
                            >Borrar Campaña</v-btn>
                            <!-- <v-btn
                                text
                                class="text-none"
                                @click="onTest"
                            >Pruebas</v-btn> -->
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn text :disabled="bEdit" @click="onClose" v-on="on">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Cerrar</span>
                            </v-tooltip>
                        </v-toolbar-items>

                        <!-- Menú lateral para dispositivos con ventanas chicas: -->
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" class="hidden-md-and-up">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list color="grey lighten-4">
                                <v-list-item :disabled="bEdit" @click="onNewCampaign">
                                    <v-list-item-title>
                                        <v-icon color="light-blue darken-4">mdi-account-plus</v-icon>&nbsp; Nuevo Administrador
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item :disabled="bEdit" @click="onEditCampaign">
                                    <v-list-item-title>
                                        <v-icon color="light-blue darken-4">mdi-account-edit</v-icon>&nbsp; Editar Administrador
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item :disabled="bEdit" @click="onDeleteCampaign">
                                    <v-list-item-title>
                                        <v-icon color="light-blue darken-4">mdi-account-remove</v-icon>&nbsp; Borrar Administrador
                                    </v-list-item-title>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item :disabled="bEdit" @click="onClose">
                                    <v-list-item-title>
                                        <v-icon color="red">mdi-close</v-icon>&nbsp; Cerrar
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar>

                    <!-- Container para lista de campañas y campaña seleccionada: -->
                    <v-container pa-2 grid-list-md>
                        <!-- Renglón único para lista de campañas y card de campaña seleccionada: -->
                        <v-layout row wrap justify-space-around>
                            <!-- Lista de Campañas: *************************** -->
                            <v-flex xs10 sm3>
                                <v-card>
                                    <v-toolbar dense color="light-blue darken-3" dark flat>
                                        <v-toolbar-title class="my-list-title">Campañas registradas</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-format-list-bulleted</v-icon>
                                    </v-toolbar>

                                    <v-list
                                        subheader
                                        dense
                                        :height="listHeight"
                                        max-height="100%"
                                        class="overflow-y-auto"
                                        :disabled="bEdit"
                                        color="grey lighten-4"
                                    >
                                        <v-list-item-group
                                            v-model="selectedCampaignIndex"
                                            color="pink accent-3"
                                            :mandatory="!bNew"
                                        >
                                            <v-list-item
                                                class="my-list-item"
                                                v-for="(campaign, i) in campaigns"
                                                :key="i"
                                                @click="selectCampaign(campaign.campaniaid)"
                                            >
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <v-container pa-0 fluid>
                                                            <v-layout row wrap>
                                                                <v-flex
                                                                    md2
                                                                    xs6
                                                                >{{ campaign.nombre }}</v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-card>
                            </v-flex>

                            <!-- Termina Lista de Campañas ********************************* -->

                            <!-- Info de campaña seleccionada: *********************** -->
                            <v-flex xs10 sm9>
                                <v-card class="grey lighten-4" ref="campaign_card">
                                    <v-toolbar :height="campaignToolbarHeight" color="light-blue lighten-1" flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >{{ selectedCampaignName }}</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-domain</v-icon>
                                    </v-toolbar>

                                    <v-card-text>
                                        <v-container>
                                            <v-layout row wrap justify-space-between>
                                                <v-flex xs2>
                                                    <v-text-field
                                                        dense
                                                        prepend-icon="mdi-counter"
                                                        name="number"
                                                        label="Número"
                                                        type="text"
                                                        v-model="number"
                                                        readonly
                                                        color="light-blue darken-4"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs5>
                                                    <v-text-field
                                                        dense
                                                        prepend-icon="mdi-calendar-month"
                                                        name="name"
                                                        label="Fecha de registro"
                                                        type="text"
                                                        v-model="registrationDate"
                                                        readonly
                                                        color="light-blue darken-4"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs12 md4>
                                                    <v-select
                                                        dense
                                                        prepend-icon="mdi-account-tie"
                                                        :items="clients"
                                                        item-text="nombre"
                                                        item-value="clienteid"
                                                        v-model="clientID"
                                                        label="Cliente"
                                                        color="light-blue darken-4"
                                                        item-color="light-blue darken-4"
                                                        no-data-text="No hay clientes registrados."
                                                        :readonly="!bEdit">
                                                    </v-select>
                                                </v-flex>
                                                <v-flex xs12 md8>
                                                    <v-text-field
                                                        dense
                                                        prepend-icon="mdi-advertisements"
                                                        name="name"
                                                        label="Nombre de la campaña"
                                                        type="text"
                                                        v-model="name"
                                                        :readonly="!bEdit"
                                                        color="light-blue darken-4"
                                                        ref="name_field"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            
                                            <v-layout row wrap>
                                                <v-flex xs4>
                                                    <v-menu
                                                        v-model="bMenuDateIni"
                                                        :close-on-content-click="false"
                                                        :nudge-right="40"
                                                        transition="scale-transition"
                                                        offset-y
                                                        min-width="290px"
                                                        :disabled="!bEdit"
                                                    >
                                                        <template
                                                            v-slot:activator="{
                                                                on,
                                                            }"
                                                        >
                                                            <v-text-field
                                                                dense
                                                                color="light-blue darken-4"
                                                                v-model="initialDate"
                                                                label="Fecha de inicio"
                                                                prepend-icon="mdi-calendar-start"
                                                                readonly
                                                                v-on="on"
                                                            ></v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            color="light-blue darken-4"
                                                            v-model="initialDate"
                                                            @input="bMenuDateIni = false"
                                                        ></v-date-picker>
                                                    </v-menu>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <v-menu
                                                        v-model="bMenuDateEnd"
                                                        :close-on-content-click="false"
                                                        :nudge-right="40"
                                                        transition="scale-transition"
                                                        offset-y
                                                        min-width="290px"
                                                        :disabled="!bEdit"
                                                    >
                                                        <template
                                                            v-slot:activator="{
                                                                on,
                                                            }"
                                                        >
                                                            <v-text-field
                                                                dense
                                                                color="light-blue darken-4"
                                                                v-model="endingDate"
                                                                label="Fecha de finalización"
                                                                prepend-icon="mdi-calendar-end"
                                                                readonly
                                                                v-on="on"
                                                            ></v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            color="light-blue darken-4"
                                                            v-model="endingDate"
                                                            @input="bMenuDateEnd = false"
                                                        ></v-date-picker>
                                                    </v-menu>
                                                </v-flex>
                                            </v-layout>
                                            
                                            <v-layout row justify-space-between>
                                                <v-flex xs6 md8 class="text-center">
                                                    <img :height="imgHeight" :src="campaignImage" />
                                                </v-flex>
                                                <v-flex xs6 md4 v-if="bEdit">
                                                    <v-container>
                                                        <v-layout row justify-center>
                                                            <v-flex
                                                                align-self-center
                                                                class="justify-center text-center"
                                                                xs12
                                                            >
                                                                <v-btn
                                                                    color="teal darken-3"
                                                                    class="text-none"
                                                                    text
                                                                    @click="onChangeImg"
                                                                >
                                                                    <span v-if="bImage === false">Agregar imagen</span>
                                                                    <span v-else >Cambiar imagen</span>
                                                                </v-btn>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row justify-center>
                                                            <v-flex
                                                                align-self-center
                                                                class="justify-center text-center"
                                                                xs12
                                                            >
                                                                <v-btn
                                                                    color="teal darken-3"
                                                                    class="text-none"
                                                                    text
                                                                    @click="onDeleteImg"
                                                                    :disabled="bImage === false"
                                                                >Borrar imagen</v-btn>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-container>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        dense
                                                        prepend-icon="mdi-label"
                                                        label="Etiqueta"
                                                        type="text"
                                                        v-model="label"
                                                        :readonly="!bEdit"
                                                        color="light-blue darken-4"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        dense
                                                        prepend-icon="mdi-web"
                                                        label="URL"
                                                        type="text"
                                                        v-model="url"
                                                        :readonly="!bEdit"
                                                        color="light-blue darken-4"
                                                    ></v-text-field>
                                                </v-flex>                                                
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12>
                                                    <v-textarea
                                                        dense
                                                        outlined
                                                        v-model="notes"
                                                        :auto-grow="false"
                                                        no-resize
                                                        color="light-blue darken-4"
                                                        label="Notas"
                                                        rows="3"
                                                        :readonly="!bEdit"
                                                    ></v-textarea>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout
                                                v-if="bEdit"
                                                align-center
                                                justify-end
                                                row
                                                fill-height
                                            >
                                                <v-flex xs12 sm8 class="text-xs-center text-end">
                                                    <v-btn
                                                        color="teal darken-3"
                                                        class="text-none"
                                                        text
                                                        @click="onSave"
                                                        :disabled="!bEdit"
                                                    >OK</v-btn>
                                                    <v-btn
                                                        color="pink darken-1"
                                                        class="text-none"
                                                        text
                                                        @click="onCancel"
                                                        :disabled="!bEdit"
                                                    >Cancelar</v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <!-- Termina info de campaña seleccionada *********************** -->
                        </v-layout>

                        <!-- Modal para confirmar borrado de campaña: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeletingCampaign" persistent width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-3" dark flat>
                                        <v-toolbar-title class="my-list-title">Borrar Campaña</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-3">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar la campaña {{ selectedCampaignName }}?
                                    </v-card-title>
                                    <v-card-text
                                        class="text-center"
                                    >Esta acción no se puede deshacer.</v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deleteCampaignConfirmed"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteCampaign"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de usuario *************************** -->

                        <!-- Modal para informar que no hubo resultados en la búsqueda: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bShowNotFoundAlert" persistent max-width="30%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="light-blue darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Búsqueda de Campañas</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >No hay campañas registradas con ese nombre.</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bShowNotFoundAlert = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para informar que no hubo resultados en la búsqueda *************************** -->

                        
                        <!-- Modal para pedir que se introduzcan todos los campos obligatorios: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bInvalidData" persistent :width="errorModalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Información Incompleta</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                    >mdi-alert</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >{{ errorMessage }}</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bInvalidData = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para pedir que se introuzcan todos los campos *********************************** -->

                        <!-- Modal para indicar que ya existe otra campaña registrada con el mismo nombre: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="duplicatedCampaignError"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Usuario Duplicado</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                    >mdi-alert</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >Ya existe otro usuario registrado con el mismo correo electrónico.</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onDuplicatedUser"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para indicar que ya existe otro usuario registrado con el mismo correo *********************************** -->

                        <!-- Modal para cargar archivo de imagen: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bChangeImageDlg" persistent max-width="30%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="light-blue darken-3" dark flat>
                                        <v-toolbar-title class="my-list-title">Imagen para la campaña</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-cloud-upload</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-file-input
                                                        color="light-blue darken-4"
                                                        accept="image/*"
                                                        show-size
                                                        label="Archivo de imagen"
                                                        v-model="imageFile"
                                                    >Imagen para la campaña</v-file-input>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onChangeImageFile"
                                        >OK</v-btn>

                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelChangeImageFile"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para cargar archivo de logo *************************** -->

                        <!-- Modal para informar que se debe seleccionar un archivo para la imagen: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bShowNullImageAlert"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Archivo de Imagen</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center text-center"
                                                >Debe seleccionar un archivo de imagen.</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bShowNullImageAlert = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para informar que se debe seleccionar un archivo para la imagen *********************************** -->

                        <!-- Modal para confirmar borrado de imagen: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeleteImageDlg" persistent max-width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-2" dark flat>
                                        <v-toolbar-title class="my-list-title">Borrar Imagen</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                        </div>&nbsp; ¿Desea borrar la imagen de la campaña?
                                    </v-card-title>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deleteImageConfirmed"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteImage"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de logo *************************** -->

                        <!-- Termina renglón único para lista de campañas y campaña seleccionada -->
                    </v-container>
                    <!-- Termina container para lista de campañas y campaña seleccionada -->
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>
        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'campaigns',
    data() {
        return {
            drawer: false,
            bMounted: false, //Para saber si ya se puede obtener la altura de los componentes.
            bEdit: false,
            bNew: false,
            campaignToolbarHeight: 48, //48 = dense
            
            bInvalidData: false,
            errorMessage: '',

            campaignID: 0,
            number: '',
            name: '',
            clientID: 0,
            label: '',
            registrationDate: '',
            initialDate: '',
            endingDate: '',
            url: '',
            notes: '',
            
            imageInfo: null, //Objeto regresado por el servidor con la información para reconstruir el archivo de imagen.
            imageFile: null, //Archivo cargado por el file input, para agregar o cambiar la imagen.
            bImage: false,
            bShowNullImageAlert: false,
            bDeleteImage: false, //Indica que, al guardar la campaña, se debe guardar su imagen.

            selectedCampaignName: '',
            bDeletingCampaign: false,
            searchText: '',
            bShowNotFoundAlert: false, //Indica si se debe mostrar el diálogo que indica que no hubo resultados en la búsqueda.

            bMenuDateIni: false,
            bMenuDateEnd: false,
            bChangeImageDlg: false,
            bDeleteImageDlg: false, //Indica si se debe mostrar el diálogo para borrar la imagen de la campaña.
            
        };
    },
    created() {
        this.selectFirstCampaign();
        //console.log('campaigns: ', this.campaigns);
    },
    mounted() {
        this.bMounted = true;
    },
    
    methods: {
        onClose() {
            this.$router.push('/');
        },


        onNewCampaign() {
            this.bEdit = true;
            this.bNew = true;
            this.selectedCampaignName = 'Nueva Campaña';
            this.selectedCampaignIndex = -1;
            
            this.campaignID = 0;

            //Obtiene el número de la nueva campaña:
            if (this.campaigns.length > 0)
            {
                this.number = this.campaigns[this.campaigns.length - 1].numero + 1;
            }
            else
            {
                this.number = 1;
            }

            this.name = '';
            this.clienteID = 0,
            this.label = '';

            const dToday = new Date();
            this.registrationDate = this.formatDate(dToday);
            this.initialDate = this.formatDate(dToday);
            this.endingDate = this.formatDate(dToday);

            this.url = '';
            this.notes = '';
            this.imageInfo = null;
            this.imageFile = null;
            this.bImage = false;
            this.campaignImage = require('@/assets/no-image.png');

            this.$refs.name_field.focus();

        },
        onDeleteCampaign() {
            this.bDeletingCampaign = true;
        },
        cancelDeleteCampaign() {
            this.bDeletingCampaign = false;
        },
        deleteCampaignConfirmed() {
            this.bDeletingCampaign = false;

            //Como el borrado en el servidor es asíncrono, antes de borrar el registro en el servidor se borra
            //el registro localmente. Si no, si el registro borrado era el primer registro, si primero se
            //borra en el servidor y después se selecciona el primer registro, es posible que se vuelva a
            //seleccionar el registro borrado antes de que éste se borre en el servidor.

            var i;
            for (i = 0; i < this.campaigns.length; i++)
            {
                if (this.campaigns[i].campaniaid === this.campaignID)
                {
                    this.campaigns.splice(i, 1);
                    break;
                }
            }

            this.$store.dispatch('deleteCampaign', this.campaignID);
            this.selectFirstCampaign();
        },
        onEditCampaign() {
           
            this.bEdit = true;
        },
        
        
        onCancel() {
            if (this.bNew) {
                //Selecciona la primera campaña de la lista:
                this.selectFirstCampaign();
                this.bNew = false;
            } else {
                
                //Vuelve a obtener los datos originales de la campaña:
                this.selectCampaign(this.campaignID);
            }
            this.bEdit = false;
        },
        onSave()
        {
            var bDataOK = false;

            //Se validan los datos:

            if (this.name === '')
            {
                this.bInvalidData = true;
                this.errorMessage = 'El nombre de la campaña es obligatorio.';
            }
            else if (this.clientID === 0)
            {
                this.bInvalidData = true;
                this.errorMessage = 'Seleccione al cliente para la campaña.';
            }
            else if (this.label === '')
            {
                this.bInvalidData = true;
                this.errorMessage = "La etiqueta de la campaña es obligatoria.";
            }
            else if (this.initialDate === '')
            {
                this.bInvalidData = true;
                this.errorMessage = "Seleccione la fecha de inicio.";
            }
            else if (this.endingDate === '')
            {
                this.bInvalidData = true;
                this.errorMessage = "Seleccione la fecha de terminación.";
            }
            else if (this.initialDate > this.endingDate)
            {
                this.bInvalidData = true;
                this.errorMessage = "La fecha de inicio no puede ser posterior a la de finalización."
            }
            else if (this.imageFile === null) //Pendiente. Checar cómo se va a validar la imagen
            {
                this.bInvalidData = true;
                this.errorMessage = "Escoja una imagen para la campaña.";
            }
            else if (this.url === '')
            {
                this.bInvalidData = true;
                this.errorMessage = "La URL es obligatoria.";
            }
            else
            {
                bDataOK = true;
            }
            if (!this.bNew && bDataOK)
            {
                //Edición de campaña...

                var campaignInfo = {
                    campaniaid: this.campaignID,
                    numero: this.number,
                    nombre: this.name,
                    clienteid: this.clientID,
                    etiqueta: this.label,
                    fechaRegistro: this.registrationDate,
                    fechaInicio: this.initialDate,
                    fechaFin: this.endingDate,
                    url: this.url,
                    notas: this.notes,
                    filedownloaduri: null,
                };

                var campaignToUpdate = {
                    campaign: campaignInfo,
                    imageFile: null,
                    deleteImage: false,
                };

                if (this.bImage && this.imageFile !== null)
                {
                    campaignToUpdate.imageFile = this.imageFile;
                }
                else
                if (this.bDeleteImage)
                {
                    campaignToUpdate.deleteImage = true;
                }

                //console.log('campaignInfo = ', campaignInfo);
                console.log('campaignToUpdate = ', campaignToUpdate);

                //Edición del registro en la BD:
                this.$store.dispatch('editCampaign', campaignToUpdate);

                //Se actualiza el registro local:
                /*for (let i = 0; i < this.campaigns.length; i++)
                {
                    if (this.campaigns[i].campaniaid === this.campaignID)
                    {
                        this.campaigns[i].numero = this.number;
                        this.campaigns[i].nombre = this.name;
                        this.campaigns[i].clienteid = this.clientID;
                        this.campaigns[i].etiqueta = this.label;
                        this.campaigns[i].fechaRegistro = this.registrationDate;
                        this.campaigns[i].fechaInicio = this.initialDate;
                        this.campaigns[i].fechaFin = this.endingDate;
                        this.campaigns[i].url = this.url;
                        this.campaigns[i].notas = this.notes;
                        this.campaigns[i].filedownloaduri = this.imageInfo;

                        break;
                    }
                }*/
            } //end edición de cliente.
            else if (this.bNew && bDataOK)
            {
                //Registro de Nueva Campaña...
                
                this.bNew = false;

                const newCampaign = {
                    campaniaid: this.campaignID,
                    numero: this.number,
                    nombre: this.name,
                    clienteid: this.clientID,
                    etiqueta: this.label,
                    fechaRegistro: this.registrationDate,
                    fechaInicio: this.initialDate,
                    fechaFin: this.endingDate,
                    url: this.url,
                    notas: this.notes,
                    filedownloaduri: null
                };

                var campaignToSave = {
                    campaign: newCampaign,
                    imageFile: null,
                    deleteFile: false
                };

                if (this.bImage && this.imageFile !== null)
                {
                    campaignToSave.imageFile = this.imageFile;
                }

                this.$store.dispatch('saveNewCampaign', campaignToSave);
            } //end registro de nuevo usuario.

            if (bDataOK)
            {
                this.selectedCampaignName = this.name;
                this.bEdit = false;
            }
        },

        selectFirstCampaign()
        {
            if (this.campaigns.length > 0)
            {
                this.selectedCampaignIndex = 0;
                var campaignID = this.campaigns[this.selectedCampaignIndex].campaniaid;
                this.selectCampaign(campaignID);
            }
            else
            {
                this.selectedCampaignIndex = -1;
                this.campaignID = 0;
            }
        },
        selectCampaign(campaignID)
        {
            for (let i = 0; i < this.campaigns.length; i++)
            {
                if (this.campaigns[i].campaniaid === campaignID)
                {
                    console.log("Campaña seleccionada: ", this.campaigns[i]);
                    this.campaignID = campaignID;

                    this.number = this.campaigns[i].numero;
                    this.name = this.campaigns[i].nombre;
                    this.clientID = this.campaigns[i].clienteid;
                    this.label = this.campaigns[i].etiqueta;
                    this.registrationDate = this.campaigns[i].fechaRegistro;
                    this.initialDate = this.campaigns[i].fechaInicio;
                    this.endingDate = this.campaigns[i].fechaFin;
                    this.url = this.campaigns[i].url;
                    this.notes = this.campaigns[i].notas;
                    this.imageInfo = this.campaigns[i].filedownloaduri;

                    if (this.imageInfo === null)
                    {
                        this.bImage = false;
                        this.campaignImage = require('@/assets/no-image.png');
                    }
                    else
                    {
                        this.bImage = true;
                        this.$store.dispatch('getCampaignImage', this.imageInfo);
                    }

                    this.selectedCampaignName = this.name;

                    break;
                }
            }
        },
        onChangeImg() {
            this.bChangeImageDlg = true;
        },
        onDeleteImg() {
            this.bDeleteImageDlg = true;
        },
        cancelDeleteImage() {
            this.bDeleteImageDlg = false;
        },
        deleteImageConfirmed() {
            this.bDeleteImageDlg = false;
            this.bImage = false;
            this.bDeleteImage = true;
            this.imageFile = null;
            this.campaignImage = require('@/assets/no-image.png');
        },

        
        onChangeImageFile() {
            if (this.imageFile === null) {
                this.bShowNullImageAlert = true;
            } else {
                this.bChangeImageDlg = false;
                console.log('imageFile = ', this.imageFile);
                var imgFileURL = URL.createObjectURL(this.imageFile);

                this.campaignImage = imgFileURL;
                this.bImage = true;
                this.bDeleteImage = false;
                console.log('onChangeImageFile, campaignImage = ', this.campaignImage);
            }
        },

        onCancelChangeImageFile() {
            this.bChangeImageDlg = false;
        },

        onSearch()
        {
            if (this.searchText != '')
            {
                //Se convierte el texto a minúsculas para hacer la comparación:

                var searchTextLowerCase = this.searchText.toLowerCase();

                var i;
                var bFound = false;
                for (i = 0; i < this.campaigns.length; i++)
                {
                    var strLowerCaseText = this.campaigns[i].nombre.toLowerCase();
                    if (strLowerCaseText.indexOf(searchTextLowerCase) === 0)
                    {
                        this.selectedCampaignIndex = i;
                        this.selectCampaign(this.campaigns[i].campaniaid);
                        bFound = true;
                        break;
                    }
                }
                if (!bFound)
                {
                    this.bShowNotFoundAlert = true;
                }
                this.searchText = '';
            }
        },

        onDuplicatedUser()
        {
            this.duplicatedCampaignError = false;
            this.selectedCampaignName = 'Nueva Campaña';
            this.bEdit = true;
            this.bNew = true;
        },

        formatDate(date)
        {
            var month = '' + (date.getMonth() + 1);
            var day = '' + date.getDate();
            var year = date.getFullYear();

            //console.log("month = ", month);
            //console.log("day = ", day);

            if (month.length < 2)
            {
                month = '0' + month;
            }
            if (day.length < 2)
            {
                day = '0' + day;
            }

            //console.log("month = ", month);
            //console.log("day = ", day);
            return [year, month, day].join('-');
        },

        onTest()
        {
            this.$store.dispatch('zoteroTest1');
        },
    },
    computed:
    {
        ...mapGetters([
            'campaigns',
            'waitCursor',
            'clients'
        ]),
        selectedCampaignIndex:
        {
            get() {
                return this.$store.getters.selectedCampaignIndex;
            },
            set(selectedCampaignIndex) {
                this.$store.dispatch('updateSelectedCampaignIndex', selectedCampaignIndex);
            },
        },
        
        duplicatedCampaignError:
        {
            get() {
                return this.$store.getters.duplicatedCampaignError;
            },
            set(duplicatedCampaignError) {
                this.$store.dispatch('setDuplicatedCampaignError', duplicatedCampaignError);
            },
        },

        campaignImage: {
            get() {
                return this.$store.getters.campaignImage;
            },
            set(campaignImage) {
                this.$store.dispatch('updateCampaignImage', campaignImage);
            }
        },

        // style="height: 578px; max-height:100%"
        listHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '200px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '700px';
            }
            else
            if (this.bMounted)
            {
                //height = this.$refs.campaign_card.$el.clientHeight - this.campaignToolbarHeight + 'px';
                height = this.$refs.campaign_card.$el.clientHeight + 'px';
            }
            else {
                height = '470px';
            }
            return height;
        },

        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        },

        imgHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '70';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '80';
            } else if (this.$vuetify.breakpoint.md) {
                height = '100';
            } else if (this.$vuetify.breakpoint.lg) {
                height = '120';
            } else {
                height = '140';
            }
            return height;
        },
    },
};
</script>

<style scoped>
.sub-window {
    /* background-color: #e0e0e0; */
    /*grey lighten-2 */
    background: rgba(224, 224, 224, 0.6);
}
.campaigns {
    background: url('../assets/fondo2.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>